/**
 * Trade Ideas Filters — compact select filters
 */
import React from 'react';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

const sx = { minWidth: 130, '& .MuiOutlinedInput-root': { borderRadius: 2, height: 36, fontSize: '0.78rem' }, '& .MuiInputLabel-root': { fontSize: '0.78rem' } };

const TradeIdeasFilters = ({ riskFilter, setRiskFilter, filterSector, setFilterSector, filterSetup, setFilterSetup, sortBy, setSortBy, sectors, setPage }) => {
  const { t } = useTranslation();
  const handle = (setter) => (e) => { setter(e.target.value); setPage(0); };

  return (
    <>
      <FormControl size="small" sx={sx}>
        <InputLabel>{t('tradingDecision.tradeIdeasTable.filters.riskLevel', 'Risk')}</InputLabel>
        <Select value={riskFilter} label={t('tradingDecision.tradeIdeasTable.filters.riskLevel', 'Risk')} onChange={handle(setRiskFilter)}>
          <MenuItem value="normal">{t('tradingDecision.tradeIdeasTable.filters.normalRisk', 'Normal')}</MenuItem>
          <MenuItem value="high-risk">{t('tradingDecision.tradeIdeasTable.filters.highRisk', 'High Risk')}</MenuItem>
          <MenuItem value="all">{t('tradingDecision.tradeIdeasTable.filters.allIdeas', 'All')}</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={sx}>
        <InputLabel>{t('tradingDecision.tradeIdeasTable.filters.sector', 'Sector')}</InputLabel>
        <Select value={filterSector} label={t('tradingDecision.tradeIdeasTable.filters.sector', 'Sector')} onChange={handle(setFilterSector)}>
          <MenuItem value="">{t('tradingDecision.tradeIdeasTable.filters.allSectors', 'All')}</MenuItem>
          {sectors.map(s => <MenuItem key={s} value={s}>{String(s)}</MenuItem>)}
        </Select>
      </FormControl>

      <FormControl size="small" sx={sx}>
        <InputLabel>{t('tradingDecision.tradeIdeasTable.filters.setup', 'Setup')}</InputLabel>
        <Select value={filterSetup} label={t('tradingDecision.tradeIdeasTable.filters.setup', 'Setup')} onChange={handle(setFilterSetup)}>
          <MenuItem value="">{t('tradingDecision.tradeIdeasTable.filters.allSetups', 'All')}</MenuItem>
          <MenuItem value="breakout">{t('tradingDecision.tradeIdeasTable.breakout', 'Breakout')}</MenuItem>
          <MenuItem value="pullback">{t('tradingDecision.tradeIdeasTable.pullback', 'Pullback')}</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={sx}>
        <InputLabel>{t('tradingDecision.tradeIdeasTable.sortBy', 'Sort')}</InputLabel>
        <Select value={sortBy} label={t('tradingDecision.tradeIdeasTable.sortBy', 'Sort')} onChange={handle(setSortBy)}>
          <MenuItem value="risk_pct">{t('tradingDecision.tradeIdeasTable.sortOptions.riskPct', 'Risk %')}</MenuItem>
          <MenuItem value="size_nav_frac">{t('tradingDecision.tradeIdeasTable.sortOptions.sizeNavFrac', 'Size %')}</MenuItem>
          <MenuItem value="rs">{t('tradingDecision.tradeIdeasTable.sortOptions.rs', 'RS')}</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export default TradeIdeasFilters;
